import React from "react"
import formatTheme from "../../utils/organism-formatting/formatTheme"
import renderPaddingOrFullBleed from "../../utils/organism-formatting/renderPaddingOrFullBleed"
import { Header } from "terra-one"

const RenderHeaderConnector = ({
  contentfulId,
  theme,
  eyebrow,
  headline,
  subhead,
  centered,
  isPageHeader,
}) => {
  return (
    <Header
      contentfulId={contentfulId}
      theme={theme}
      eyebrow={eyebrow}
      headline={headline}
      subhead={subhead}
      centered={centered}
      isPageHeader={isPageHeader}
    />
  )
}
const HeaderConnector = ({
  data = {},
  disablePadding,
  overrideTheme,
  marginTopAndBottom,
  productPage,
  isPageHeader,
}) => {
  const { contentfulId, eyebrow, headline, subhead, nested, alignment } = data
  const centerHeader = alignment === "Center" ? true : false
  const themeValue =
    overrideTheme ||
    data?.colorScheme?.split(" ").join("-").toLowerCase() ||
    "transparent-light-text"
  const theme = formatTheme({ theme: themeValue })
  // by default header does not have contentWidth as a prop. We add contentWidth in FullBackgroundHero so that this component does not have extra padding.
  const contentWidth =
    data?.contentWidth === false ? (disablePadding = true) : true

  return disablePadding ? (
    <RenderHeaderConnector
      contentfulId={contentfulId}
      theme={theme}
      eyebrow={eyebrow}
      headline={headline}
      subhead={subhead}
      centered={centerHeader}
      isPageHeader={isPageHeader}
    />
  ) : (
    renderPaddingOrFullBleed(
      <RenderHeaderConnector
        contentfulId={contentfulId}
        theme={!productPage ? theme : "transparent-dark-text"}
        eyebrow={eyebrow}
        headline={headline}
        subhead={subhead}
        centered={!productPage ? centerHeader : false}
        isPageHeader={isPageHeader}
      />,
      true,
      true,
      true,
      nested,
      marginTopAndBottom,
      null,
      productPage ? "product-page-component" : null
    )
  )
}

export default HeaderConnector
